export default "__VITE_ASSET__DvJqIOZh__"